// extracted by mini-css-extract-plugin
export default {"FullResolutionData":"FullResolutionData_FullResolutionData__EE7VQ","ResolutionDataContainer":"FullResolutionData_ResolutionDataContainer__e46t4"};